<!-- Main Layout Container -->
<div class="layout-container" [class.sidebar-closed]="!sidebarOpen">
  <!-- Header -->
  <header class="layout-header" [class.sidebar-open]="sidebarOpen">
    <div class="header-content">
      <!-- Sidebar Toggle Button -->
      <button 
        class="sidebar-toggle" 
        (click)="toggleSidebar()"
        title="{{ sidebarOpen ? 'Close sidebar' : 'Open sidebar' }}"
        aria-label="{{ sidebarOpen ? 'Close sidebar' : 'Open sidebar' }}"
      >
        <i class="pi" [class]="sidebarOpen ? 'pi-times' : 'pi-bars'"></i>
      </button>
      
      <!-- Header Title -->
      <div class="header-title">
        <h1 class="app-title">GoVideo</h1>
      </div>
      
      <!-- Header Actions -->
      <div class="header-actions">
        <!-- What's New / Notifications Button -->
        <button 
          class="action-button notification-button" 
          title="What's New"
          (click)="showWhatsNew()"
        >
          <i class="pi pi-bell"></i>
          @if (hasUnseenUpdates) {
            <span class="notification-badge"></span>
          }
        </button>
        
        <!-- Theme Toggle -->
        <div class="theme-toggle-wrapper">
          <button 
            class="action-button theme-button" 
            (click)="toggleThemeMenu()"
            title="Theme: {{ getThemeLabel(currentTheme) }}"
            aria-label="Theme: {{ getThemeLabel(currentTheme) }}"
          >
            <i class="pi" [ngClass]="getThemeIcon()"></i>
          </button>
          
          <!-- Theme Menu Dropdown -->
          <div class="theme-menu" [class.open]="themeMenuOpen">
            <div class="theme-menu-header">
              <span>Theme</span>
            </div>
            <div class="theme-options">
              <button 
                class="theme-option" 
                [class.active]="currentTheme === 'light'"
                (click)="setTheme('light')"
              >
                <i class="pi pi-sun"></i>
                <span>Light</span>
                @if (currentTheme === 'light') {
                  <i class="pi pi-check"></i>
                }
              </button>
              <button 
                class="theme-option" 
                [class.active]="currentTheme === 'dark'"
                (click)="setTheme('dark')"
              >
                <i class="pi pi-moon"></i>
                <span>Dark</span>
                @if (currentTheme === 'dark') {
                  <i class="pi pi-check"></i>
                }
              </button>
              <button 
                class="theme-option" 
                [class.active]="currentTheme === 'system'"
                (click)="setTheme('system')"
              >
                <i class="pi pi-desktop"></i>
                <span>System</span>
                @if (currentTheme === 'system') {
                  <i class="pi pi-check"></i>
                }
              </button>
            </div>
          </div>
        </div>
        
        <button class="action-button" title="Settings">
          <i class="pi pi-cog"></i>
        </button>
        <div class="user-menu">
          <button class="user-button" title="Coordinator menu">
            <i class="pi pi-user"></i>
            <span class="user-name">Coordinator</span>
            <i class="pi pi-chevron-down"></i>
          </button>
        </div>
      </div>
    </div>
  </header>

  <!-- Sidebar -->
  <aside class="layout-sidebar" [class.open]="sidebarOpen">
    <div class="sidebar-content">
      <!-- Navigation Menu -->
      <nav class="sidebar-nav">
        <ul class="nav-list">
          <li class="nav-item">
            <a routerLink="/sessions" class="nav-link active" [class.active]="activeRoute === 'sessions'" (click)="setActiveRoute('sessions')">
              <i class="pi pi-video"></i>
              <span class="nav-text">Session Manager</span>
            </a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" (click)="setActiveRoute('analytics')">
              <i class="pi pi-chart-bar"></i>
              <span class="nav-text">Analytics</span>
            </a>
          </li>
        </ul>
        
        <!-- Sidebar Footer Links -->
        <div class="sidebar-footer-links">
          <ul class="nav-list">
            <li class="nav-item">
              <a href="#" class="nav-link" (click)="setActiveRoute('settings')">
                <i class="pi pi-cog"></i>
                <span class="nav-text">Settings</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </aside>

  <!-- Main Content Area -->
  <main class="layout-content" [class.sidebar-open]="sidebarOpen">
    <div class="content-wrapper">
      <!-- Content will be projected here -->
      <ng-content></ng-content>
    </div>
  </main>

  <!-- Footer -->
  <footer class="layout-footer" [class.sidebar-open]="sidebarOpen">
    <div class="footer-content">
      <div class="footer-left">
        <span class="copyright">&copy; 2025 GoVideo. All rights reserved.</span>
      </div>
      <div class="footer-right">
        <button 
          class="version-info" 
          (click)="showWhatsNew()"
          title="View What's New"
        >
          <span class="version">v{{ versionInfo.version }}</span>
          <span class="metadata">
            <span class="build-date">{{ formatBuildDate(versionInfo.buildDate) }}</span>
            <span class="commit-sha">{{ versionInfo.commitSha }}</span>
          </span>
        </button>
        <span class="divider">|</span>
        <a href="#" class="footer-link">Privacy Policy</a>
        <span class="divider">|</span>
        <a href="#" class="footer-link">Terms of Service</a>
      </div>
    </div>
  </footer>

  <!-- What's New Dialog -->
  <app-whats-new-dialog></app-whats-new-dialog>

  <!-- Sidebar Backdrop (for mobile) -->
  <div 
    class="sidebar-backdrop" 
    [class.visible]="sidebarOpen && isMobile" 
    (click)="closeSidebar()"
  ></div>
</div>